import { render, staticRenderFns } from "./MResetPass.vue?vue&type=template&id=e742664a&scoped=true&"
import script from "./MResetPass.vue?vue&type=script&lang=ts&"
export * from "./MResetPass.vue?vue&type=script&lang=ts&"
import style0 from "./MResetPass.vue?vue&type=style&index=0&id=e742664a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e742664a",
  null
  
)

export default component.exports